import { round } from "es-toolkit";
import { useEffect, useState } from "react";

import { formatDecimalValue, formatUSD } from "@/utils/currency";

export const useNumberCounter = (
  endValue: number,
  decimalPlaces: number = 0,
  isUsd: boolean = true,
  duration: number = 800,
) => {
  const [count, setCount] = useState("0");

  useEffect(() => {
    let startTime: number | null = null;
    let animationFrameId: number;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(duration ? progress / duration : 1, 1);
      const currentCount = round(percentage * endValue, decimalPlaces);
      const formattedCount = isUsd
        ? formatUSD(currentCount)
        : formatDecimalValue(currentCount);

      setCount(formattedCount);

      if (percentage < 1) {
        animationFrameId = requestAnimationFrame(animate);
      }
    };

    animationFrameId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrameId);
  }, [endValue, duration]);

  return count;
};
